import { render, staticRenderFns } from "./allhis.vue?vue&type=template&id=24d5751b&scoped=true"
import script from "./allhis.vue?vue&type=script&lang=js"
export * from "./allhis.vue?vue&type=script&lang=js"
import style0 from "./allhis.vue?vue&type=style&index=0&id=24d5751b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5751b",
  null
  
)

export default component.exports